(function () {
  var MQ = window.matchMedia('(max-width: 767px)');
  var instances = new WeakMap(); // el -> flkty instance

  function init(el) {
    if (instances.get(el)) return; // already init
    var opts = getOptions(el);
    // Force options we rely on
    opts.imagesLoaded = true;
    opts.cellAlign = opts.cellAlign || 'left';
    opts.contain = (opts.contain !== false);

    var flkty = new Flickity(el, opts);
    instances.set(el, flkty);

    // Safety: resize when each image finishes to prevent cut-offs
    el.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () { flkty.resize(); }, { once: true });
    });

    // If container visibility changes (AOS/accordions), resize again
    requestAnimationFrame(function(){ flkty.resize(); });
    setTimeout(function(){ flkty.resize(); }, 300);
  }

  function destroy(el) {
    var flkty = instances.get(el);
    if (!flkty) return;
    flkty.destroy();
    instances.delete(el);
  }

  function getOptions(el) {
    try {
      var data = el.getAttribute('data-flickity');
      return data ? JSON.parse(data) : {};
    } catch (e) {
      return {};
    }
  }

  function refreshAll() {
    var els = document.querySelectorAll('.flickity-enabled-on-mobile');
    els.forEach(function (el) {
      if (MQ.matches) {
        init(el);
      } else {
        destroy(el);
      }
    });
  }

  // Debounced resize toggling
  var rAF;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(refreshAll);
  });

  document.addEventListener('DOMContentLoaded', refreshAll);

  // Shopify Theme Editor events (re-render, select, etc.)
  document.addEventListener('shopify:section:load', refreshAll);
  document.addEventListener('shopify:section:unload', refreshAll);
  document.addEventListener('shopify:section:select', refreshAll);
  document.addEventListener('shopify:section:deselect', refreshAll);
  document.addEventListener('shopify:block:select', refreshAll);
  document.addEventListener('shopify:block:deselect', refreshAll);
})();
